import { FlashcardsApp as AppToResolved } from "./AppToResolved";

export function FlashcardsApp() {
	return <AppToResolved />;
}
